import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/perfiles',documento:'catalogs',acceso:'sesion',filas:['076'],cita:'Areas/Catalogs/Controllers/ProfilesController.cs:28'} satisfies RutaProd;
